import React from "react";
import {ColumnLayout, Select} from "@amzn/awsui-components-react";

export class SourceCard extends React.Component {

  constructor(props) {
    super(props);
    this.state = {...this.props.data};
  }

  handleChange = (change, e) => {
    const newState = {};
    const newSource = e.detail.selectedId;
    newState[change] = newSource;
    let prevCount = 1;
    for (let prevSource of this.props.allSources.filter((x, ind) => ind < this.props.allSources.indexOf(this.props.data))) {
      if (prevSource.source === newSource) {
        prevCount += 1
      }
    }
    if (prevCount > 1) {
      newState['alias'] = `${newSource}_${prevCount}`;
    } else {
      newState['alias'] = newSource
    }
    this.setState(newState, () => {
      this.props.onChange({...this.state});
    });
  }

  handleMainChange = (change, e) => {
    const newState = {};
    newState[change] = e.detail.selectedId;
    this.setState(newState, () => {
      this.props.onChange({...this.state});
    });
  }

  render() {
    let extraAliasColumn = "";
    if (this.props.alias !== this.props.data.source) {
      extraAliasColumn = <div style={{marginTop: "25px"}}>
        Source alias: {this.props.alias}
      </div>;
    }
    return <ColumnLayout columns={this.props.alias === this.props.data.source? 2: 3}>
      <div data-awsui-column-layout-root="true">
        <div>
          Source:
          <Select options={this.props.sources.map((x) => ({label: x.jobName, id: x.jobName}))}
                  selectedOption={{
                    label: this.props.data.source,
                    id: this.props.data.source
                  }}
                  onChange={(e) => this.handleChange('source', e)}
                  selectedLabel="Selected"
                  filteringType={"auto"}
                  disabled={this.props.disabled}/>
        </div>
        {extraAliasColumn}
        <div>
          Is this the main source for original/transform saving purposes?
          <Select options={[{label: "True", id: true}, {label: "False", id: false}]}
                  selectedOption={{
                    label: this.props.data.is_main? "True": "False",
                    id: this.props.data.is_main
                  }}
                  onChange={(e) => this.handleMainChange('is_main', e)}
                  selectedLabel="Selected"
                  disabled={this.props.disabled || this.props.allSources.filter(x => this.props.data.guid !== x.guid).some(x => x.is_main)}/>
        </div>
      </div>
    </ColumnLayout>;
  }
}
